import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, ButtonGroup, Col, Input, Label, Modal, ModalBody, Row, Spinner } from "@/Components/ui";
;
import { API, BACKEND_HOST } from "../api";
import { useAuthContext } from "./AuthContext";
import { dialogService } from "@/utils/dialogService";
const ReservationAddModal = ({ show, onAddClick, onCloseClick, reservDate, reservProduct }) => {
    const { userInfo } = useAuthContext();
    const [phoneNum, setPhoneNum] = useState("");
    const [spots, setSpots] = React.useState([]);
    const [selectedSpots, setSelectedSpots] = React.useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [userSearch, setUserSearch] = React.useState("");
    const [userList, setUserlist] = React.useState([]);
    const [isNotify, setIsNotify] = useState(false);
    const [paidAmount, setPaidAmount] = useState(0);
    const [customerDisplayName, setCustomerDisplayName] = useState("");
    const searchUser = useCallback(() => {
        setSearchLoading(false);
        if (!userSearch) {
            setUserlist([]);
        }
        else {
            setSearchLoading(true);
            API.get(`${BACKEND_HOST}/accounts/users-crm?search=${userSearch}`)
                .then(async (res) => {
                console.log("search load:", res.data);
                if (res.data?.results)
                    setUserlist(res.data.results);
                else
                    await dialogService.handleAlert("search error...");
                setSearchLoading(false);
            })
                .catch(async (e) => {
                await dialogService.handleAlert(e, { force: "error" });
                setSearchLoading(false);
            });
        }
    }, [userSearch]);
    const abortController = useRef(null);
    useEffect(() => {
        console.log("ReservationAddModal useEffect", reservDate, reservProduct);
        if (show && reservDate && reservProduct) {
            if (abortController.current)
                abortController.current.abort("AbortError");
            abortController.current = new AbortController();
            API.get(`${BACKEND_HOST}/package/items/?date=${reservDate}`, {
                signal: abortController.current.signal,
            })
                .then(({ data }) => {
                // console.log("products spot load:", data)
                const _product = data.find((item) => {
                    return item.name === reservProduct;
                });
                if (_product && _product["spots"]) {
                    setSpots(_product["spots"]);
                }
            })
                .catch((e) => {
                if (e.name === "AbortError") {
                    console.log(e);
                }
            });
        }
        else {
            setSpots([]);
            setSelectedSpots([]); // Clear selected spots when no product is selected
            setCustomerDisplayName("");
        }
    }, [show, reservDate, reservProduct]);
    const checkData = async () => {
        if (!reservDate || !reservProduct || selectedSpots.length === 0) {
            await dialogService.handleAlert("필수 입력값이 없습니다.");
            return null;
        }
        let _phoneNum = phoneNum;
        if (!_phoneNum) {
            if (await dialogService.confirm("전화번호가 입력되지 않았습니다. 관리자 정보로 등록하시겠습니까?")) {
                _phoneNum = userInfo.phone_num;
            }
            else {
                await dialogService.handleAlert("전화번호를 입력해 주세요.");
                return null;
            }
        }
        // const data = {
        //   phoneNum: _phoneNum,
        //   reservDate: reservDate,
        //   reservProduct: reservProduct,
        //   spot: spotId,
        //   notifyUser: isNotify,
        //   paidAmount: paidAmount,
        // };
        const data = selectedSpots.map(spot => ({
            phoneNum: _phoneNum,
            reservDate: reservDate,
            reservProduct: reservProduct,
            spot: spot,
            notifyUser: isNotify,
            paidAmount: paidAmount,
            customerDisplayName: customerDisplayName,
        }));
        return data;
    };
    const clearAllSpots = () => {
        setSelectedSpots([]);
    };
    return (<Modal isOpen={show} onClose={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <Row>
              <Col>
                <div className="mb-3">
                  <Label htmlFor="phonenumberInput" className="form-label">
                    고객 전화번호
                  </Label>
                  <Input type="text" className="form-control" placeholder="고객정보를 검색해서 선택해 주세요" id="phoneNum" value={phoneNum} onChange={(e) => { }} maxLength="11" disabled/>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                    <input onChange={(e) => {
            setUserSearch(e.target.value);
        }} id="search-bar-0" type="text" className="form-control search mt-1" style={{ width: "80%" }} placeholder={`Search User here...`} value={userSearch}/>
                    <Button onClick={() => {
            searchUser();
        }} color="soft-light" className="me-1 text-dark">
                      <i className="bx bx-search-alt search-icon"></i>
                    </Button>
                    <Button onClick={() => {
            setUserSearch("");
            setUserlist([]);
        }} color="soft-secondary" className="me-1">
                      <i className="bx bx-reset"></i>
                    </Button>
                  </div>
                  <div className="text-muted text-sm">
                    입력하지 않으면 관리자 정보로 등록됩니다.
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                {searchLoading ? (<div style={{}}>
                    <Spinner color="primary"> Searching... </Spinner>
                  </div>) : null}
                {!!userList &&
            userList.map((user, idx) => {
                if (idx > 4)
                    return null;
                return (<Button className="m-1" key={user.id} color="link" style={{ boxShadow: "none" }} onClick={() => {
                        setPhoneNum(user["전화번호"]);
                    }}>
                        <span>
                          {user["이름"]} {user["전화번호"]}
                        </span>
                      </Button>);
            })}
                <span>{!!userList && userList.length > 5 ? "..." : null}</span>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="mb-3">
                  <Label htmlFor="customerDisplayName" className="form-label">
                    표시 이름
                  </Label>
                  <Input type="text" className="form-control" placeholder="예약 목록에 표시할 이름" id="customerDisplayName" value={customerDisplayName} onChange={(e) => {
            setCustomerDisplayName(e.target.value);
        }} maxLength="50"/>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="mb-3">
                  <Label htmlFor="firstNameinput" className="form-label">
                    예약날짜
                  </Label>
                  <Input type="text" className="form-control" placeholder="예약날짜" id="reservation-date" value={reservDate} onChange={(e) => { }} maxLength="11" disabled/>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <Label htmlFor="formFile" className="form-label">
                    예약상품
                  </Label>
                  <Input type="text" className="form-control" placeholder="" id="reservation-product" value={reservProduct} onChange={(e) => { }} maxLength="100" disabled/>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <Label htmlFor="formFile" className="form-label">
                    선택된 자리번호 ({selectedSpots.length}개 선택됨)
                  </Label>
                  <div className="d-flex">
                    <Input type="text" className="form-control" placeholder="자리를 선택해주세요" id="spot" value={selectedSpots.map(spot => spot.name).join(', ')} maxLength="100" disabled/>
                    {selectedSpots.length > 0 && (<Button className="ms-2" color="secondary" outline size="sm" onClick={clearAllSpots} title="모든 선택 해제">
                        <i className="bx bx-x"></i>
                      </Button>)}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="mb-3">
                <div style={{ marginTop: "27px", display: "flex", flexWrap: "wrap", alignContent: "start", alignItems: "start", justifyItems: "start", justifyContent: "start", gap: "5px" }}>
                  {spots.map((spot, idx) => {
            const isSelected = selectedSpots.some(selectedSpot => selectedSpot.name === spot.name);
            return (<Button key={idx} id={`spot-checkbox-${idx}`} color={spot.is_able ? (isSelected ? "success" : "primary") : "danger"} outline={!isSelected} value={spot.name} onClick={() => {
                    if (spot.is_able) {
                        if (isSelected) {
                            // Remove from selection
                            setSelectedSpots(prev => prev.filter(s => s.name !== spot.name));
                        }
                        else {
                            // Add to selection
                            setSelectedSpots(prev => [...prev, spot]);
                        }
                    }
                }} disabled={!spot.is_able && spot.reason?.includes("reservation")} style={{
                    width: "38px",
                    height: "38px",
                    paidding: "0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "14px",
                }}>
                        <span>{spot.name}</span>
                      </Button>);
        })}
                </div>
                <div className="mt-2">
                  <small className="text-muted">
                    클릭하여 여러 자리를 선택/해제할 수 있습니다. 선택된 자리는 녹색으로 표시됩니다.
                  </small>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="mb-3">
                  <Label htmlFor="firstNameinput" className="form-label">
                    결제금액
                  </Label>
                  <Input type="text" className="form-control" placeholder="결제금액" id="paid-amount" value={paidAmount} onChange={(e) => {
            setPaidAmount(e.target.value);
        }} maxLength="11"/>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="mb-3">
                  <Label htmlFor="firstNameinput" className="form-label">
                    알림여부
                  </Label>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="notify" id="notify-yes" value="true" checked={isNotify === true} onChange={(e) => {
            setIsNotify(true);
        }}/>
                    <label className="form-check-label" htmlFor="notify-yes">
                      예
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="notify" id="notify-no" value="false" checked={isNotify === false} onChange={(e) => {
            setIsNotify(false);
        }}/>
                    <label className="form-check-label" htmlFor="notify-no">
                      아니오
                    </label>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <Button type="button" data-bs-dismiss="modal" onClick={onCloseClick} color="light">
            Close
          </Button>
          <Button type="button" id="delete-record" onClick={async () => {
            const data = await checkData();
            if (data === null)
                return;
            if (selectedSpots.length > 1) {
                if (!await dialogService.confirm(`${selectedSpots.length}개의 자리를 모두 예약하시겠습니까?\n선택된 자리: ${selectedSpots.map(s => s.name).join(', ')}`)) {
                    return;
                }
            }
            onAddClick(data);
            onCloseClick();
        }} color="danger">
            예약 추가하기 ({selectedSpots.length}개 자리)
          </Button>
        </div>
      </ModalBody>
    </Modal>);
};
ReservationAddModal.propTypes = {
    onCloseClick: PropTypes.func,
    onAddClick: PropTypes.func,
    show: PropTypes.any,
};
export default ReservationAddModal;
